import DataTransformer from 'wixPaste/DataTransformer';
import _ from 'ckLodash';
import deleteContents from 'wixPaste/deleteContents';
import experiments from 'utils/experiments';
import pasteUtils from 'utils/pasteUtils';
import utils from 'utils/utils';
import wixCopy from 'wixPaste/wixCopy';


function pasteEvtHasSourceEditor() {
    return !(CKEDITOR.env.gecko || CKEDITOR.env.ie);
}

function executeExternalPasteEvt(evtInfo, dataTranformer, editor) {
    //Santa editor is listening to externalPasteHandle and update the pasted data,
    //for example links data queries fix
    var externalPasteHandleObj = {
        pasteString: dataTranformer.getHtml(),
        isExternalSourceData: isFromOutsideCk(evtInfo)
    };
    editor.fire('externalPasteHandle', externalPasteHandleObj);
    if (dataTranformer.getHtml() !== externalPasteHandleObj.pasteString) {
        var newHtml = editor.dataProcessor.toHtml(externalPasteHandleObj.pasteString, {fixForBody: false});
        dataTranformer.setHtmlData(newHtml);
    }
}

function isFromOutsideCk(evt) {
    var result;
    if (!pasteEvtHasSourceEditor() && wixCopy.getLastCopiedData().lastCopiedTextNoSpace) {
        result = wixCopy.getLastCopiedData().lastCopiedTextNoSpace !== utils.removeSpaces(utils.getPlainTextFromHtml(evt.data.dataValue));
    } else {
        result = !evt.data.dataTransfer.sourceEditor;
    }
    return result;
}

function shouldUseLastCopiedData(evtInfo, lastCopiedData) {
    return !isFromOutsideCk(evtInfo) && lastCopiedData.hasSavedState;
}

function getWrappedHtmlFromLastCopied(selectionIntention, lastCopiedData, dataValue) {
    if (selectionIntention.getThemeClass() === lastCopiedData.theme) {
        dataValue = lastCopiedData.textWithOverrides;
    } else {
        dataValue = lastCopiedData.textWithAllThemeOverrides;
    }
    return dataValue;
}

function getDataValueFromSavedState(evtInfo, selectionIntention, dataValue = evtInfo.data.dataValue) {
    const lastCopiedData = wixCopy.getLastCopiedData();
    if (shouldUseLastCopiedData(evtInfo, lastCopiedData)) {
        dataValue = getWrappedHtmlFromLastCopied(selectionIntention, lastCopiedData, dataValue);
    } else if (!isFromOutsideCk(evtInfo) && utils.isIE()) {
        dataValue = wixCopy.getLastCopiedData().ieHtml;
    } else if (isFromOutsideCk(evtInfo) && experiments.isOpen('se_pasteMultilineTextStyles')) {
        // https://jira.wixpress.com/browse/WEED-31540
        // we need to NOT preserve source formatting when pasting from outside CK, apply local styles, and remove html tags
        dataValue = evtInfo.data.dataTransfer
            .getData('text/plain')
            .replaceAll('\n', '<br>');
    }
    return dataValue;
}

function getDataTransformer(editor, dataValue) {
    var allowLists = !utils.isListStateOn(editor);
    return new DataTransformer(dataValue, allowLists, editor);
}


function getCurrentDataQuery(range) {
    var linkElement = _.find(range.startPath().elements, function (element) {
        return element.getName() === 'a';
    });
    return _.invoke(linkElement, 'getAttribute', 'dataquery');
}

function applyTransformationForPasteIntoLink(selectionIntention, dataTransformer) {
    var dataQuery = getCurrentDataQuery(selectionIntention.getRange());
    if (dataQuery) {
        dataTransformer.removeUnderlines()
            .removeLinks()
            .wrapTextNodesInUnderline()
            .wrapTextNodesInATag(dataQuery);
    }
}

function applyTransformationForExternalPaste(dataTransformer) {
    dataTransformer.cleanExternalHtml();
    if (dataTransformer.getBlockCount()) {
        dataTransformer
            .fixOrphans()
            .trimEmptyLines()
            .fixDefaultThemesForTags()
            .fixListThemes()
            .unWrapIfSingleBlock();
    }
}

function applyTransformationForInternalPaste(dataTransformer, evtInfo, selectionIntention) {
    dataTransformer.trimEmptyLines();
    if (!isFromOutsideCk(evtInfo) && !dataTransformer.getBlockCount()) {
        applyTransformationForPasteIntoLink(selectionIntention, dataTransformer);
    }
}

function isPastingIntoList(editor) {
    return editor.getCommand('numberedlist').state !== CKEDITOR.TRISTATE_OFF || editor.getCommand('bulletedlist').state !== CKEDITOR.TRISTATE_OFF;
}

function applyTransformationOnPastedData(evtInfo, dataTransformer, selectionIntention, editor) {
    if (isFromOutsideCk(evtInfo)) {
        applyTransformationForExternalPaste(dataTransformer);
    } else {
        applyTransformationForInternalPaste(dataTransformer, evtInfo, selectionIntention);
    }
    if (isPastingIntoList(editor)) {
        dataTransformer.wrapBlocksInLi();
    }
}

function onPaste(evtInfo) {
    evtInfo.editor.undoManager.lock(true);
    let selectionIntention;
    const editor = evtInfo.editor;
    if (evtInfo.data.method !== 'drop') {
        selectionIntention = deleteContents.deleteSelectionContents(editor);
    }
    const dataValue = getDataValueFromSavedState(evtInfo, selectionIntention);
    const dataTransformer = getDataTransformer(editor, dataValue).removeCkBrEol();

    applyTransformationOnPastedData(evtInfo, dataTransformer, selectionIntention, editor);
    executeExternalPasteEvt(evtInfo, dataTransformer, editor);

    if (evtInfo.data.method !== 'drop') {
        pasteUtils.cleanInsertHtml(editor, dataTransformer, selectionIntention, isFromOutsideCk(evtInfo));
    } else {
        editor.insertHtml(dataTransformer.getHtml(), dataTransformer.getBlockCount() ? 'html' : 'text');
    }

    stopEvt(evtInfo);
    editor.execCommand('autogrow');
}

function stopEvt(evtInfo) {
    unlockUndoManager(evtInfo.editor);
    evtInfo.cancel();
    evtInfo.stop();
}

function unlockUndoManager(editor) {
    editor.undoManager.unlock();
    editor.fire('change');
}

function init(editor) {
    editor.on('dragstart', function (evt) {
        evt.cancel();
        evt.stop();
    });

    editor.on('paste', onPaste, null, null, 5);
    editor.pasteFilter = null;
}


export default {
    init: init
};
